import ActionCableLink from 'graphql-ruby-client/subscriptions/ActionCableLink'

import { TActionCableClient } from '../../ActionCableClient'

type TCreateSubscriptionLinkOptions = {
  actionCableClient: TActionCableClient
}

/**
 * creates an Apollo GQL client Subscription link
 * using the ActionCable client (for our Ruby BE) and web sockets
 * filling it with required info (user token, endpoint)
 * ! this is a terminating link and it should be placed at the end of the link array
 * https://www.apollographql.com/docs/react/api/link/introduction#the-terminating-link
 * https://medium.com/@jerridan/implementing-graphql-subscriptions-in-rails-and-react-9e05ca8d6b20
 */
export const createSubscriptionLink = ({ actionCableClient }: TCreateSubscriptionLinkOptions) => {
  return new ActionCableLink({ cable: actionCableClient.consumer })
}
